<template>
  <div>
    <Filters
      :hide="hideFinished"
      :order="sortingOrder"
      @sort="sortingOrder = $event"
      @hide="hideFinished = $event"
    />
    <div v-if="exams.length" class="exams">
      <router-link
        v-for="exam in exams"
        :key="exam.id"
        :to="{
        name: 'Exam',
        params: { id: `${exam.id}` }
      }"
        class="exam">
        <exam-info :exam="exam">
          <template slot="actions">
            <span class="exam-actions">
              <span class="save-action" @click.prevent="savePapers(exam.id)"></span>
              <span class="edit-action" @click.prevent="editExam(exam.id)"></span>
              <span class="delete-action" @click.prevent="deleteExam(exam.id)"></span>
            </span>
          </template>
        </exam-info>
      </router-link>

    </div>
    <div v-else class="stub">
      <h1>{{ $t('exams.STUB') }}</h1>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import ExamInfo from '@/components/room/ExamInfo.vue'
import { makeSessionLinks, saveJSONAsXLSX } from '@/utils/utils.format'
import Filters from '@/components/Filters'
import orderBy from 'lodash/orderBy'

export default {
  name: 'Exams',
  components: {
    Filters,
    ExamInfo
  },
  created () {
    this.$loading.start()

    this.fetchExams()
      .then(exams => {
        this.rawExams = exams
      })
      .catch(() => this.$loading.fail())
      .finally(() => this.$loading.done())

    this.hideFinished = JSON.parse(localStorage.getItem('hide')) || false
    this.sortingOrder = JSON.parse(localStorage.getItem('order')) || 'desc'
  },
  data () {
    return {
      rawExams: [],
      hideFinished: undefined,
      sortingOrder: undefined
    }
  },
  computed: {
    exams () {
      const sorted = orderBy(this.rawExams, ['start'], [this.sortingOrder])

      if (!this.hideFinished) return sorted
      return sorted.filter(exam => new Date(exam.end) > new Date())
    }
  },
  methods: {
    deleteExam (examId) {
      const rawIndex = this.rawExams.findIndex(exam => exam.id === examId)
      this.deleteExamAction(examId)
        .then(() => this.rawExams.splice(rawIndex, 1))
        .catch(() => this.$awn.alert(this.$t('exams.DELETE_FAILURE')))
    },
    editExam (examId) {
      this.$router.push({ name: 'EditExam', params: { id: examId } })
    },
    savePapers (examId) {
      this.fetchExamStudents(examId)
        .then(sessions => {
          const name = 'sessions'
          const links = makeSessionLinks(sessions)
          saveJSONAsXLSX(links, name)
        })
        .catch(() => this.$awn.alert(this.$t('exams.SAVE_FAILURE')))
    },
    ...mapActions([
      'fetchExams',
      'deleteExamAction',
      'fetchExamStudents'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.exams {
  margin: 32px auto;
  width: 100%;
  max-width: 640px;

  .exam {
    position: relative;
    display: block;
    padding: 16px;
    margin-bottom: 24px;
    background-color: $paper-bg;

    box-shadow: 0 1px 2px rgba(0, 150, 136, 0.6);
    transition: box-shadow .3s ease;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      box-shadow: 0 1px 3px 0 rgba(0, 150, 136, 0.6);

      opacity: 0;
      transition: opacity .3s;

    }

    &:hover::before {
      opacity: 1;
    }
  }
}

</style>
